import { ThankYou } from "./components/ThankYou";
import { Home } from "./components/Home";
import { Error } from "./components/Error";
import { Construction } from "./components/Construction";
import { ContactUs } from "./components/ContactUs";

const AppRoutes = [
  {
    index: true,
    element: <Home />,
  },
  {
    path: "/ThankYou",
    element: <ThankYou />,
  },
  {
    path: "/Error",
    element: <Error />,
  },
  {
    path: "/Construction",
    element: <Construction />,
  },
  {
    path: "/ContactUs",
    element: <ContactUs />,
  },
];

export default AppRoutes;
